import { render, staticRenderFns } from "./ManualTests.vue?vue&type=template&id=4579b7f4&"
import script from "./ManualTests.vue?vue&type=script&lang=js&"
export * from "./ManualTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports